import React, { useState, useEffect } from 'react';
import MyinvBasic from './MyinvBasic'; // Fixed: Changed back to correct case
import { get_myinvestment_investment } from '../../services/common';
import moment from 'moment';

const MyinvInvestment = ({ myinvId }) => {
  const [principles, setPrinciples] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [myinvestment, setMyinvestment] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (myinvId) {
      getInvestmentBasic();
    }
  }, [myinvId]);

  const getInvestmentBasic = async () => {
    try {
      const userToken = localStorage.getItem('systemToken') || '';
      const response = await get_myinvestment_investment(userToken, myinvId);
      
      if (response.success === 200) {
        const principlesData = response.principles;
        const transactionsData = response.transactions;
        const investmentData = response.investment;

        // Format principles data
        const formattedPrinciples = principlesData.map(principle => ({
          ...principle,
          principle_start_date: moment(principle.principle_start_date).format('DD-MM-YYYY'),
          maturity_date: moment(investmentData.myinvestment_maturity_date).format('DD-MM-YYYY'),
          principle_invested_amount: `${investmentData.currency_symbol} ${(typeof principle.principle_invested_amount !== 'undefined' ? principle.principle_invested_amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0)}`,
          principle_paid_amount: `${investmentData.currency_symbol} ${(typeof principle.principle_paid_amount !== 'undefined' ? principle.principle_paid_amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0)}`,
          principle_amount: `${investmentData.currency_symbol} ${(typeof principle.principle_amount !== 'undefined' ? principle.principle_amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0)}`,
        }));

        // Format transactions data
        const formattedTransactions = transactionsData.map(transaction => ({
          ...transaction,
          trans_date: moment(transaction.trans_date).format('DD-MM-YYYY'),
          trans_credit: transaction.trans_type === 2 
            ? `${transaction.currency_symbol} ${(typeof transaction.trans_amount !== 'undefined' ? transaction.trans_amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0)}`
            : '-',
          trans_debit: transaction.trans_type !== 2 
            ? `${transaction.currency_symbol} ${(typeof transaction.trans_amount !== 'undefined' ? transaction.trans_amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0)}`
            : '-',
        }));

        setPrinciples(formattedPrinciples);
        setTransactions(formattedTransactions);
        setMyinvestment(investmentData);
      }
    } catch (error) {
      console.error('Error fetching investment data:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="w-full px-1 py-3 border-b">
        <div className="flex justify-center items-center py-4">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500"></div>
          <span className="ml-2">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full px-1 py-3 border-b">
      <MyinvBasic myinvId={myinvId} />
      
      <div className="w-full mt-4 px-3">
        <div className="w-full overflow-x-auto">
          <table className="min-w-full table-auto border-collapse border border-gray-300">
            <thead>
              <tr className="bg-gray-50">
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date Invested</th>
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Invested Amount</th>
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Principle Amt Paid</th>
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Principle Balance</th>
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Maturity Date</th>
              </tr>
            </thead>
            <tbody>
              {principles.length > 0 ? (
                principles.map((principle) => (
                  <tr key={principle.trans_id} className="hover:bg-gray-50">
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                      {principle.principle_start_date}
                    </td>
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                      {principle.principle_invested_amount}
                    </td>
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                      {principle.principle_paid_amount}
                    </td>
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                      {principle.principle_amount}
                    </td>
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                      {principle.maturity_date}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="border border-gray-300 px-2 py-1 text-center text-gray-500">
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="w-full mt-4 px-3">
        <div className="w-full overflow-x-auto">
          <table className="min-w-full table-auto border-collapse border border-gray-300">
            <thead>
              <tr className="bg-gray-50">
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ minWidth: '110px' }}>Date</th>
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Description</th>
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ minWidth: '135px' }}>Credit</th>
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ minWidth: '135px' }}>Debit</th>
              </tr>
            </thead>
            <tbody>
              {transactions.length > 0 ? (
                transactions.map((transaction) => (
                  <tr key={transaction.trans_id} className="hover:bg-gray-50">
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                      {transaction.trans_date}
                    </td>
                    <td className="border border-gray-300 px-2 py-1 text-sm" style={{ whiteSpace: 'normal' }}>
                      {transaction.ref_description}
                    </td>
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap" style={{ minWidth: '135px' }}>
                      {transaction.trans_credit}
                    </td>
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap" style={{ minWidth: '135px' }}>
                      {transaction.trans_debit}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="border border-gray-300 px-2 py-1 text-center text-gray-500">
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MyinvInvestment;
